var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRaccoon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#401409"
    },
    d: "M168.118,178.797c7.429-7.915,7.033-20.405-0.885-27.837l-57.436-53.902 c-3.665-3.44-8.448-5.334-13.468-5.334c-5.502,0-10.605,2.208-14.368,6.216c-4.682,4.989-6.428,11.924-4.672,18.555 c1.415,5.343,19.701,72.405,27.354,100.464C122.508,212.267,157.334,190.288,168.118,178.797z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACABB1"
    },
    d: "M194.186,122.243L136.75,68.34C125.756,58.023,111.402,52.34,96.33,52.34 c-16.258,0-31.962,6.798-43.085,18.649c-14.038,14.961-19.281,35.742-14.026,55.59C41.039,133.457,68.8,235.212,69.98,239.54 l1.465,5.368l4.058,3.807c4.145,3.89,11.565,8.527,23.377,8.527c14.198,0,33.002-6.829,55.885-20.298 c17.093-10.06,33.999-22.596,42.069-31.195C219.127,181.996,217.937,144.536,194.186,122.243z M81.963,97.942 c3.763-4.009,8.865-6.216,14.368-6.216c5.02,0,9.803,1.893,13.468,5.334l57.435,53.902c7.918,7.432,8.314,19.922,0.885,27.837 c-10.785,11.491-45.609,33.47-63.472,38.164c-7.652-28.059-25.94-95.12-27.354-100.464C75.536,109.866,77.282,102.93,81.963,97.942z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#401409"
    },
    d: "M430.037,97.943c-3.763-4.011-8.865-6.218-14.368-6.218c-5.02,0-9.803,1.893-13.467,5.334 l-57.437,53.903c-7.916,7.431-8.313,19.921-0.882,27.837c10.784,11.49,45.607,33.469,63.472,38.162 c7.655-28.063,25.94-95.119,27.354-100.462C436.464,109.866,434.718,102.93,430.037,97.943z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#818085"
    },
    d: "M458.755,70.991c-11.124-11.852-26.827-18.65-43.085-18.65c-15.071,0-29.426,5.682-40.419,16.001 l-57.437,53.904c-23.75,22.292-24.94,59.753-2.649,83.506c8.07,8.598,24.976,21.134,42.069,31.193 c22.885,13.468,41.686,20.298,55.884,20.299c0.001,0,0.001,0,0.003,0c11.811,0,19.233-4.637,23.376-8.527l4.058-3.807l1.465-5.368 c1.182-4.328,28.941-106.082,30.762-112.96C478.037,106.73,472.794,85.949,458.755,70.991z M343.883,178.798 c-7.431-7.916-7.034-20.406,0.882-27.837l57.437-53.903c3.665-3.44,8.448-5.334,13.467-5.334c5.502,0,10.605,2.208,14.368,6.218 c4.682,4.987,6.428,11.923,4.671,18.555c-1.414,5.343-19.699,72.401-27.354,100.462C389.49,212.267,354.666,190.288,343.883,178.798 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DEDDE0"
    },
    d: "M256,459.659L0,360.103v-13.471c0-28.476,8.902-59.013,26.46-90.762 c15.432-27.904,37.302-55.893,63.246-80.943C143.558,122.933,207.279,90.633,256,90.633s112.442,32.301,166.294,84.295 c25.944,25.05,47.814,53.039,63.246,80.943c17.558,31.748,26.46,62.284,26.46,90.762v13.471L256,459.659z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDCDD0"
    },
    d: "M256,90.633c48.721,0,112.442,32.301,166.294,84.295c25.944,25.05,47.814,53.039,63.246,80.943 c17.558,31.748,26.46,62.284,26.46,90.762v13.471L256,459.66"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACABB1"
    },
    d: "M223.179,280.992c0-47.053-38.281-85.333-85.333-85.333H69.772 c-17.265,19.329-32.02,39.792-43.314,60.213C8.902,287.619,0,318.156,0,346.633v13.471l15.998,6.221h121.848 C184.899,366.326,223.179,328.044,223.179,280.992z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#818085"
    },
    d: "M512,346.633c0-28.476-8.902-59.013-26.46-90.762c-11.294-20.422-26.049-40.885-43.314-60.213 h-68.072c-47.053,0-85.333,38.281-85.333,85.333s38.281,85.333,85.333,85.333h121.848L512,360.103V346.633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACABB1"
    },
    d: "M275.692,189.095V92.251c-6.779-1.062-13.365-1.617-19.692-1.617c-6.328,0-12.913,0.557-19.692,1.617 v96.844L275.692,189.095L275.692,189.095z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#401409"
    },
    cx: 144.41,
    cy: 280.996,
    r: 19.692
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#401409"
    },
    d: "M269.128,346.633H256h-13.128c-7.251,0-13.128,5.877-13.128,13.128 c0,13.128,26.256,26.256,26.256,26.256s26.256-13.128,26.256-26.256C282.256,352.509,276.379,346.633,269.128,346.633z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#401409"
    },
    cx: 367.59,
    cy: 280.996,
    r: 19.692
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaccoon);
export default __webpack_public_path__ + "static/media/raccoon.e112f34e2dec7e4afe241fd2bf249277.svg";
export { ForwardRef as ReactComponent };